module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBox),
      expression: "showBox"
    }],
    ref: "box",
    staticClass: "box-login"
  }, [_c('div', {
    staticClass: "login-box"
  }, [_c('h1', {
    staticClass: "title",
    style: ({
      'background-color': _vm.color
    })
  }, [_c('div', [_vm._v("验证信息")])]), _vm._v(" "), _c('div', {
    staticClass: "login-content"
  }, [_c('p', {
    staticStyle: {
      "margin-bottom": "32px"
    }
  }, [_c('label', [_vm._v("手机号/邮箱")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneEmail),
      expression: "phoneEmail"
    }],
    attrs: {
      "type": "text",
      "placeholder": "手机号/邮箱"
    },
    domProps: {
      "value": (_vm.phoneEmail)
    },
    on: {
      "blur": _vm.yanPhone,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneEmail = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.showPhoneEmailErr) ? _c('span', {
    staticClass: "tips"
  }, [_vm._v("请输入合法的手机号/邮箱")]) : _vm._e()]), _vm._v(" "), _c('p', [_c('label', [_vm._v("验证码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticStyle: {
      "width": "162px"
    },
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "blur": _vm.yanCode,
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "get-code",
    style: ({
      'border-color': _vm.color,
      'color': _vm.color
    }),
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v(_vm._s(_vm.codeText))]), _vm._v(" "), (_vm.codeErr) ? _c('span', {
    staticClass: "tips"
  }, [_vm._v("请输入验证码")]) : _vm._e(), _vm._v(" "), (_vm.codeErr2) ? _c('span', {
    staticClass: "tips"
  }, [_vm._v("请输入合法的手机号/邮箱")]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "45px",
      "margin-top": "43px",
      "color": "#000000",
      "font-size": "14px"
    }
  }, [_vm._v("手机收不到验证码？ "), _c('span', {
    staticClass: "yuyin",
    staticStyle: {
      "color": "red"
    },
    on: {
      "click": _vm.getyuCode
    }
  }, [_vm._v("试试语音验证码")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "50px"
    }
  }, [_c('input', {
    style: ({
      'background-color': _vm.color
    }),
    attrs: {
      "type": "button",
      "value": "确定"
    },
    on: {
      "click": _vm.login
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cf3566fc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/login.vue
// module id = 824
// module chunks = 10